export default {"src":"/_next/static/media/skype.b5a0529b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};